export default __webpack_public_path__ + "static/media/inPatient.42f15420.svg";